import getEnvironDomain from 'ati-utils/getEnvironDomain';

export default () => getEnvironDomain() || 'ati.su';
